<template>
  <label @click.stop="emit('onClick')">
    <input
      ref="inputElement"
      type="text"
      :value="value"
      :readonly="readonly"
      class="peer relative w-full bg-white px-3 pb-2 pt-8 leading-relaxed focus:z-10 focus:outline-none"
      :class="{
        'rounded-l-xl': roundedLeft,
        'rounded-r-xl': roundedRight,
        'rounded-xl': rounded,
        'z-10 ring-[3px] ring-purple-400 ': isActive,
        'z-10 ring-[3px] ring-red-500': isError,
      }"
      :placeholder="placeholder"
      @input="emit('onInput', $event)"
      @focus="emit('onFocus', $event)"
    />

    <strong
      class="absolute left-3 top-2 text-sm font-normal text-gray-500 peer-focus:z-10"
      :class="{ 'z-10': isActive || isError }"
    >
      {{ title }}
    </strong>
  </label>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  defineProps<{
    value?: string;
    title: string;
    readonly?: boolean;
    isActive?: boolean;
    isError?: boolean;
    placeholder?: string;
    roundedLeft?: boolean;
    roundedRight?: boolean;
    rounded?: boolean;
  }>();

  const emit = defineEmits<{
    onFocus: [event: Event];
    onInput: [event: Event];
    onClick: [];
  }>();

  const inputElement = ref<HTMLElement | null>(null);

  function focus() {
    inputElement.value?.focus();
  }

  defineExpose({
    focus,
  });
</script>
